import React from "react";
import EducationDudakRenklendirme from "../Components/education/EducationDudakRenklendirme";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function EducationDudakRenklendirmePage() {
  return (
    <>
      <TopBar />
      <Spacer2 />
      <EducationDudakRenklendirme />
    </>
  );
}

export default EducationDudakRenklendirmePage;
